import React from 'react';
import Select from 'react-select';
import api from '../api';

export default class CitySelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {cities: []};
    }
    componentDidMount() {
        api.get('cities').then(res => {
            var cities = res.value;
            this.setState({
                cities: Object.keys(cities).map(k => cities[k])
            })
        });
    }
    render () {
        var ops = this.state.cities.map(city =>
            ({
                label: city,
                value: city
            })
        );
        return (
            <Select
                placeholder="City"
                options={ops}
                value={this.props.city}
                onChange={this.props.onChange} />
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/CitySelect.js